export default {
  state: {
    msg: {
      timeout: 10000,
      show: false,
      data: {
        text: '',
        type: 'error',
      },
    },
  },

  getters: {
    getmsg: (state) => state.msg,
  },

  mutations: {
    hidemsg(state) {
      state.msg.show = false;
      state.msg.data.text = '';
    },

    showmsg(state, msg) {
      state.msg.data = {
        ...state.msg.data,
        ...msg,
      };

      state.msg.show = true;

      state.msg.timeout = !msg.timeout
        ? 10000
        : msg.timeout;
    },

    setmsg(state, show) {
      state.msg.show = show;
    },
  },
};
